import { StackIcon } from "@radix-ui/react-icons";
import { observer } from "mobx-react-lite";

import { useUnifiedRegistry } from "../unified-registry-context";
import { getEntityColor, getTypeIcon as getEntityTypeIcon } from "../utils";

import MultiSelect from "./MultiSelect";
import { typeOptions } from "./utils";

import { EntityType } from "@/queries";

const TriggerIcon: React.FC<{
  entityTypesCount: number;
  firstEntityType: EntityType | undefined;
  getEntityColorFn: (type: EntityType) => string;
  getTypeIconFn: (type: EntityType) => React.ReactNode;
}> = ({ entityTypesCount, firstEntityType, getEntityColorFn, getTypeIconFn }) => {
  if (entityTypesCount === 1 && firstEntityType) {
    return (
      <div
        className={`flex h-5 w-5 items-center justify-center rounded ${getEntityColorFn(
          firstEntityType,
        )}`}
      >
        {getTypeIconFn(firstEntityType)}
      </div>
    );
  }

  if (entityTypesCount > 1) {
    return <StackIcon className="h-4 w-4 text-gray-600" />;
  }

  return null;
};

const TypeFilter: React.FC = () => {
  const registry = useUnifiedRegistry();

  const multiSelectOptions = typeOptions.map(option => ({
    value: option.value,
    label: option.label,
    icon: getEntityTypeIcon(option.value),
    backgroundColor: getEntityColor(option.value),
  }));

  return (
    <MultiSelect
      options={multiSelectOptions}
      selectedValues={registry.entityTypes ?? []}
      onValueChange={newTypes => registry.setEntityTypes(newTypes as EntityType[])}
      placeholder="Type"
      triggerIcon={
        <TriggerIcon
          entityTypesCount={registry.entityTypes?.length ?? 0}
          firstEntityType={registry.entityTypes?.[0]}
          getEntityColorFn={getEntityColor}
          getTypeIconFn={getEntityTypeIcon}
        />
      }
      aria-label={`Filter by type${
        (registry.entityTypes?.length ?? 0) > 0
          ? ` (${registry.entityTypes?.length ?? 0} selected)`
          : ""
      }`}
    />
  );
};

export default observer(TypeFilter);
